// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.philosophy-page {
  --ph-type-heading: clamp(2.1rem, 3vw, 3rem);
  --ph-type-subheading: 1.6rem;
  --ph-type-card-heading: 1.3rem;
  --ph-type-body: 1.08rem;
  --ph-type-label: 0.9rem;
  --bg: #f6f2fa;
  --surface: #ffffff;
  --text: #0b1220;
  --muted: #5f6175;
  --accent: #400C4D;
  --accent-soft: #e9dff8;
  --border: rgba(64, 12, 77, 0.15);
  background: var(--bg);
  color: var(--text);
  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  min-height: 100vh;
  width: 100%;
  padding: 36px 0.5rem 60px;
}

.philosophy-hero {
  max-width: 1200px;
  margin: 0 auto 44px;
  text-align: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 6px 20px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 700;
  letter-spacing: 0.2em;
  font-size: var(--ph-type-label);
  text-transform: uppercase;
  border: 1px solid var(--border);
}

.philosophy-hero h1 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-heading);
  font-weight: 800;
  margin: 16px 0;
}

.philosophy-hero h1 span {
  display: block;
  color: var(--accent);
}

.philosophy-hero p {
  max-width: 760px;
  margin: 0 auto;
  color: var(--muted);
  line-height: 1.7;
  font-size: var(--ph-type-body);
}

.founder-section {
  max-width: 1460px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.founder-card {
  background: var(--surface);
  border-radius: 28px;
  padding: 32px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 36px;
  border: 1px solid var(--border);
  box-shadow: 0 16px 40px rgba(64, 12, 77, 0.1);
}

.founder-image {
  position: relative;
  min-height: 340px;
  border-radius: 24px;
  overflow: hidden;
  background: #ece4ed;
}

.founder-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-label {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  font-size: var(--ph-type-label);
  letter-spacing: 0.12em;
  padding: 6px 10px;
  border-radius: 999px;
}

.founder-content h2 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-subheading);
  margin: 6px 0 12px;
}

.founder-role {
  font-weight: 700;
  color: var(--accent);
  letter-spacing: 0.12em;
  font-size: var(--ph-type-label);
}

.quote-card {
  background: var(--accent-soft);
  padding: 24px;
  border-radius: 22px;
  margin-bottom: 20px;
  border: 1px solid var(--border);
}

.quote-icon {
  font-size: 2rem;
  color: var(--accent);
  display: block;
  line-height: 1;
}

.quote-icon--end {
  text-align: right;
  margin-top: 0.25rem;
}

.quote-card p {
  margin: 0;
  color: var(--text);
  font-weight: 600;
  line-height: 1.5;
  font-size: var(--ph-type-body);
}

.founder-description {
  color: var(--muted);
  line-height: 1.65;
  font-size: var(--ph-type-body);
}

.philosophy-page section {
  max-width: 1200px;
  margin: 0 auto 32px;
  padding: 0 4px;
}

.philosophy-page section h2 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-subheading);
  margin-bottom: 10px;
  color: var(--accent);
}

.philosophy-page section p {
  color: var(--muted);
  line-height: 1.6;
  font-size: var(--ph-type-body);
}

.philosophy-page section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 12px;
}

.philosophy-page section li {
  position: relative;
  padding-left: 1rem;
  font-weight: 600;
  font-size: var(--ph-type-body);
}

.legacy-section li {
  color: #400C4D;
}

.culture-section li {
  color: #400C4D;
}

.philosophy-page section li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--accent);
  font-size: 1.2rem;
  line-height: 1;
}

.legacy-note,
.culture-affirmation {
  color: #111111;
  font-weight: 700;
}

.message-section {
  border-top: 1px solid var(--border);
  padding-top: 24px;
  margin-top: 24px;
}

.message-hindi {
  font-size: clamp(1.9rem, 2.5vw, 2.3rem);
  font-weight: 600;
  line-height: 1.7;
  white-space: pre-line;
  color: orangered !important;

}

@media (max-width: 900px) {
  .founder-card {
    grid-template-columns: 1fr;
  }

  .founder-image {
    min-height: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Philosophy/philosophy.css"],"names":[],"mappings":"AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,4EAA4E;EAC5E,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,6EAA6E;EAC7E,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6EAA6E;EAC7E,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;;AAE7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap\");\n\n.philosophy-page {\n  --ph-type-heading: clamp(2.1rem, 3vw, 3rem);\n  --ph-type-subheading: 1.6rem;\n  --ph-type-card-heading: 1.3rem;\n  --ph-type-body: 1.08rem;\n  --ph-type-label: 0.9rem;\n  --bg: #f6f2fa;\n  --surface: #ffffff;\n  --text: #0b1220;\n  --muted: #5f6175;\n  --accent: #400C4D;\n  --accent-soft: #e9dff8;\n  --border: rgba(64, 12, 77, 0.15);\n  background: var(--bg);\n  color: var(--text);\n  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n  min-height: 100vh;\n  width: 100%;\n  padding: 36px 0.5rem 60px;\n}\n\n.philosophy-hero {\n  max-width: 1200px;\n  margin: 0 auto 44px;\n  text-align: center;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 6px 20px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  color: var(--accent);\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  font-size: var(--ph-type-label);\n  text-transform: uppercase;\n  border: 1px solid var(--border);\n}\n\n.philosophy-hero h1 {\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n  font-size: var(--ph-type-heading);\n  font-weight: 800;\n  margin: 16px 0;\n}\n\n.philosophy-hero h1 span {\n  display: block;\n  color: var(--accent);\n}\n\n.philosophy-hero p {\n  max-width: 760px;\n  margin: 0 auto;\n  color: var(--muted);\n  line-height: 1.7;\n  font-size: var(--ph-type-body);\n}\n\n.founder-section {\n  max-width: 1460px;\n  margin: 0 auto 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.founder-card {\n  background: var(--surface);\n  border-radius: 28px;\n  padding: 32px;\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 36px;\n  border: 1px solid var(--border);\n  box-shadow: 0 16px 40px rgba(64, 12, 77, 0.1);\n}\n\n.founder-image {\n  position: relative;\n  min-height: 340px;\n  border-radius: 24px;\n  overflow: hidden;\n  background: #ece4ed;\n}\n\n.founder-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.image-label {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  background: rgba(0, 0, 0, 0.72);\n  color: #fff;\n  font-size: var(--ph-type-label);\n  letter-spacing: 0.12em;\n  padding: 6px 10px;\n  border-radius: 999px;\n}\n\n.founder-content h2 {\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n  font-size: var(--ph-type-subheading);\n  margin: 6px 0 12px;\n}\n\n.founder-role {\n  font-weight: 700;\n  color: var(--accent);\n  letter-spacing: 0.12em;\n  font-size: var(--ph-type-label);\n}\n\n.quote-card {\n  background: var(--accent-soft);\n  padding: 24px;\n  border-radius: 22px;\n  margin-bottom: 20px;\n  border: 1px solid var(--border);\n}\n\n.quote-icon {\n  font-size: 2rem;\n  color: var(--accent);\n  display: block;\n  line-height: 1;\n}\n\n.quote-icon--end {\n  text-align: right;\n  margin-top: 0.25rem;\n}\n\n.quote-card p {\n  margin: 0;\n  color: var(--text);\n  font-weight: 600;\n  line-height: 1.5;\n  font-size: var(--ph-type-body);\n}\n\n.founder-description {\n  color: var(--muted);\n  line-height: 1.65;\n  font-size: var(--ph-type-body);\n}\n\n.philosophy-page section {\n  max-width: 1200px;\n  margin: 0 auto 32px;\n  padding: 0 4px;\n}\n\n.philosophy-page section h2 {\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n  font-size: var(--ph-type-subheading);\n  margin-bottom: 10px;\n  color: var(--accent);\n}\n\n.philosophy-page section p {\n  color: var(--muted);\n  line-height: 1.6;\n  font-size: var(--ph-type-body);\n}\n\n.philosophy-page section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 12px;\n}\n\n.philosophy-page section li {\n  position: relative;\n  padding-left: 1rem;\n  font-weight: 600;\n  font-size: var(--ph-type-body);\n}\n\n.legacy-section li {\n  color: #400C4D;\n}\n\n.culture-section li {\n  color: #400C4D;\n}\n\n.philosophy-page section li::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--accent);\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.legacy-note,\n.culture-affirmation {\n  color: #111111;\n  font-weight: 700;\n}\n\n.message-section {\n  border-top: 1px solid var(--border);\n  padding-top: 24px;\n  margin-top: 24px;\n}\n\n.message-hindi {\n  font-size: clamp(1.9rem, 2.5vw, 2.3rem);\n  font-weight: 600;\n  line-height: 1.7;\n  white-space: pre-line;\n  color: orangered !important;\n\n}\n\n@media (max-width: 900px) {\n  .founder-card {\n    grid-template-columns: 1fr;\n  }\n\n  .founder-image {\n    min-height: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
